import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from 'api/axiosBaseQuery'

const accountPrivacyApi = createApi({
  baseQuery: axiosBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL ?? ''
  }),
  reducerPath: 'accountPrivacyApi',
  tagTypes: ['AccountPrivacy'],
  endpoints: () => ({})
})

export default accountPrivacyApi
